var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/smiley/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"mod-plugin-smiley\">\n    <div class=\"mod-smiley-list\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("t", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        <div class=\"mod-smiley-item\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") > 1) {
output += "style=\"display:none;\"";
;
}
output += ">\n            <div class=\"J_Wrapper wrapper\">\n                <div class=\"J_Scroller scroller\">\n                    ";
if(runtime.memberLookup((t_4),"type") == "default") {
output += "\n                    <div class=\"J_SmileyItem item\">\n                        <ul>\n                            ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"data");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("value", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") != 98) {
output += "\n                                    <li  data-id=\"";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "\">\n                                        <div class=\"smiley\" style=\"background-position: 0px -";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") - 1) * 32, env.opts.autoescape);
output += "px\"></div>\n                                    </li>\n                                ";
;
}
output += "\n                            ";
output += "\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") % 24 == 0) {
output += "\n                        </ul>\n                    </div>\n                    <div class=\"J_SmileyItem item\">\n                        <ul>\n                            ";
;
}
output += "\n                            ";
;
}
}
frame = frame.pop();
output += "\n                        </ul>\n                    </div>\n                    ";
;
}
else {
output += "\n                    <div class=\"J_SmileyItem item gif-item ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += "-item\">\n                        <ul>\n                            ";
frame = frame.push();
var t_11 = runtime.memberLookup((t_4),"data");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("value", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                            ";
if(runtime.memberLookup((t_4),"type") == "xm") {
output += "\n                            <li data-id=\"[";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((t_12),0), env.opts.autoescape);
output += "]\" type=\"liveImage\" data-gif=\"";
output += runtime.suppressValue((lineno = 32, colno = 103, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((t_12),1)),"replace"), "value[\"1\"][\"replace\"]", context, ["png","gif"])), env.opts.autoescape);
output += "\">\n                            ";
;
}
else {
output += "\n                            <li data-id=\"[";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((t_12),0), env.opts.autoescape);
output += "]\" type=\"liveImage\" data-gif=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),1), env.opts.autoescape);
output += "\">\n                            ";
;
}
output += "\n                                <div class=\"smiley\" style=\"background-position: 0px -";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") - 1) * 57, env.opts.autoescape);
output += "px\"></div>\n                                <p>";
output += runtime.suppressValue(runtime.memberLookup((t_12),0), env.opts.autoescape);
output += "</p>\n                            </li>\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") % 8 == 0 && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") < runtime.memberLookup((runtime.memberLookup((t_4),"data")),"length")) {
output += "\n                        </ul>\n                    </div>\n                    <div class=\"J_SmileyItem item gif-item ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += "-item\">\n                        <ul>\n                            ";
;
}
output += "\n                            ";
;
}
}
frame = frame.pop();
output += "\n                        </ul>\n                    </div>\n                    ";
;
}
output += "\n                </div>\n            </div>\n\n            <div id=\"mod-plugin-smiley-indicator\" class=\"indicator\">\n                <div class=\"dotty\"></div>\n            </div>\n        </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n    <div class=\"mod-smiley-tab\">\n        ";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("t", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n        <div class=\"item ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 1) {
output += "selected";
;
}
output += " J_Tab\">\n            <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_16),"icon"), env.opts.autoescape);
output += "\" alt=\"\">\n        </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/smiley/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/smiley/tpl.html
// module id = 301
// module chunks = 0 1